<template>
  <div>

    <h4>Dane do kalendarza</h4>
    <v-text-field  :label="`Szablon nazwy eventu` + '*'" v-model="eventName"  @change="updateCalendar($event)" class="schema-name-input"></v-text-field>
    <v-textarea  :label="`Szablon opisu eventu` + '*'" v-model="eventDescription"  @change="updateCalendar($event)" class="schema-name-input"></v-textarea>
    <v-text-field  :label="`Szablon daty` + '*'"  v-model="eventDate"  @change="updateCalendar($event)" class="schema-name-input"></v-text-field>
    <v-text-field  :label="`Szablon godziny` + '*'"  v-model="eventTime"  @change="updateCalendar($event)" class="schema-name-input"></v-text-field>


    <v-menu offset-y>
      <template v-slot:activator="{ on }">
        <div :style="getColorIconStyle(colorToHex())" ></div>
            <v-text-field label="Kolor" v-model="hexColor" v-on="on" @change="updateCalendar($event)" class="schema-name-input"></v-text-field>
      </template>

      <v-container style="background-color: #ffffff">
        <color-picker v-bind="color" @input="onInput"></color-picker>
      </v-container>
    </v-menu>

  </div>
</template>

<script>
import Color from '@/mixins/color'
import ColorPicker from '@radial-color-picker/vue-color-picker';
export default {
  mixins:[Color],
  components: { ColorPicker },
  name: "CalendarData",
  data(){
    return {
      eventName:'',
      eventDescription:'',
      eventDate:'',
      eventTime:'',
    }
  },
   methods: {
     getCalendarData(){
       return {
         name_template:this.eventName,
         description_template:this.eventDescription,
         date_template:this.eventDate,
         time_template:this.eventTime,
         color:this.hexColor
       }
     },
     updateCalendar(){
       this.$emit('updated', { data : this.getCalendarData()})
     }
   }
}
</script>

<style scoped>
@import '~@radial-color-picker/vue-color-picker/dist/vue-color-picker.min.css';
</style>